import { render, staticRenderFns } from "./timeline-widget.vue?vue&type=template&id=1c30c4f9&"
import script from "./timeline-widget.vue?vue&type=script&lang=ts&"
export * from "./timeline-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports